module.exports = __webpack_public_path__ + "media/images/application/template/30-second-quote/both-mobile-747559afd92455100acefee113a32ace.png";